import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react'
import {
    Grid, Typography, Button,useMediaQuery, 
    FormControlLabel, FormGroup, FormControl, 
    Checkbox, FormHelperText,
    
} from "@mui/material";
import { fetchData, postData } from '../../../../redux/apiSlice';
import { useDispatch } from 'react-redux';
import * as Yup from 'yup';
import { Formik } from 'formik';
import Backdrop from '@mui/material/Backdrop';
import Freez from '../../../../Components/Loader/Loader';
import {  useNavigate,useParams} from 'react-router-dom';

function ServiceStep2({ onNext, formData,onPrevious,transformedVideo,onSkipToStep5,setSkippedToStep5 }) {
    const dispatch = useDispatch();
    const isMobile = useMediaQuery('(max-width:600px)');
    const [mediaServiceVideos, setMediaServiceVideos] = useState([]);
    const [selectedVideos, setSelectedVideos] = useState(formData?.video_ids || []);
    const navigate = useNavigate();
    const [freez, setFreez] = React.useState(false);
    const disabledVideoIds = transformedVideo.map(video => video.id);
    const handleFreezStop = () => {
    setFreez(false);
    };
    const handleFreezStart = () => {
    setFreez(true);
    };
    const handleCheckboxChange = (event, video, setFieldValue, values) => {
        const checked = event.target.checked;
        const current = values.video_data || [];
    
        let updatedSelected;
    
        if (checked) {
            updatedSelected = [...current, { id: video.id, title: video.service_name }];
        } else {
            updatedSelected = current.filter((v) => v.id !== video.id);
        }
    
        // Ensure no duplicates
        const unique = updatedSelected.filter(
            (v, i, self) => i === self.findIndex((o) => o.id === v.id)
        );
    
        setSelectedVideos(unique.map(v => v.id));
        setFieldValue('video_data', unique);
    };

    const fetchMediaServiceVideos = async () => {
        handleFreezStart();
        const apiUrl = '/mediaServiceVideos';
        const res = await dispatch(fetchData(apiUrl)).unwrap();
        if (res) {
            setMediaServiceVideos(res.data);
            handleFreezStop();
        }else{
            handleFreezStop();
        }
    }
    useEffect(() => {
        fetchMediaServiceVideos();
    }, [])

    return (
        <>
            <Grid container item lg={12} md={12} sm={12} xs={12} mt={2}>
                <Typography variant="h6" fontWeight={"bolder"} textTransform={"capitalize"}>Which videos would you like to film? Select all that apply:</Typography>
            </Grid>
            <Formik
                initialValues={{
                    video_data: formData?.video_data || [],
                }}
                onSubmit={(values, errors) => {
                    if(values.video_data.length === 0){
                         setSkippedToStep5(true);
                        onSkipToStep5();
                       
                    }
                    else{
                    onNext(values);
                    }
                }}
            >
                {({ handleSubmit,handleChange, handleBlur,values,setFieldValue  }) => (
                    <form onSubmit={handleSubmit} style={{ width: "100%" }}>
                        <Grid container item lg={12} md={12} sm={12} xs={12} spacing={isMobile ? 0 : 2}>
                            {Array.isArray(mediaServiceVideos) &&
                                mediaServiceVideos
                                .filter((video) => video.service_type === "video")
                                .map((video) => (
                                    <Grid item key={video.id} lg={6} md={6} sm={12} xs={12}>
                                        <FormControl>
                                            <FormGroup>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={values.video_data.some((v) => v.id === video.id)}
                                                            onChange={(e) => handleCheckboxChange(e, video, setFieldValue, values)}
                                                            // onChange={(e) => handleCheckboxChange(e, video.id)}
                                                            disabled={disabledVideoIds.includes(video.id)}
                                                            name={`video-${video.id}`}
                                                            sx={{
                                                                '&:not(.Mui-disabled)': {
                                                                  color: '#2C1A95',  // blue color only when enabled
                                                                  '&.Mui-checked': {
                                                                    color: '#2C1A95',
                                                                  },
                                                                  '& .MuiSvgIcon-root': {
                                                                    fill: '#2C1A95',
                                                                  },
                                                                  '&:hover': {
                                                                    backgroundColor: 'transparent',
                                                                  },
                                                                },
                                                              }}
                                                        />
                                                    }
                                                    label={video.service_name}
                                                />
                                            </FormGroup>
                                            <FormHelperText sx={{ textTransform: "capitalize" }}>
                                                {video.service_description}</FormHelperText>

                                        </FormControl>

                                    </Grid>
                                ))}
                        </Grid>
                        <Grid container item lg={12} md={12} sm={12} xs={12} mt={2} gap={2} justifyContent={isMobile?"center":"left"}>
                            <Button variant="contained" color='primary' sx={{ minWidth: 200, fontWeight: "bold" }} type='submit' >Next</Button>
                           {(values.video_data.length === 0 || JSON.stringify(values.video_data) === JSON.stringify(formData?.video_data || [])) && (
                            <Button variant="outlined" color='primary' sx={{ minWidth: 200, fontWeight: "bold" }} onClick={onSkipToStep5}>Skip</Button>
                              )}
                            <Button variant="text"  onClick={onPrevious} color='primary' sx={{ minWidth: 200, fontWeight: "bold", fontSize: "15px" }} >previous step</Button>
                        </Grid>
                    </form>
                )}
            </Formik>
            <div>
                <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.modal + 1 }}
                    open={freez}
                >
                    <Freez />
                </Backdrop>
            </div>
        </>
    )
}
export default ServiceStep2;